import {
  addbbs,
  approvalbbs,
  approvaldownbbs, bbsTop,
  delbbs,
  editbbs,
  getbbsDetail,
  getbbslist,
  getbbslistbyPro
} from '../../services/bbsapi'

export default {
  state: {},
  mutations: {},
  actions: {
    getbbslist (store, params) {
      return getbbslist(params)
    },
    getbbslistbyPro (store, params) {
      return getbbslistbyPro(params)
    },
    addbbs (store, params) {
      return addbbs(params)
    },
    getbbsDetail (store, {id}) {
      return getbbsDetail(id)
    },
    delbbs (store, params) {
      return delbbs(params)
    },
    approvalbbs (store, params) {
      return approvalbbs(params)
    },
    approvaldownbbs (store, params) {
      return approvaldownbbs(params)
    },
    editbbs (store, {postId, params}) {
      return editbbs(postId, params)
    },
    bbsTop(store , params){
      bbsTop(params)
    }
  }
}
